<template>
  <div class="luckDraw">
    <div class="top" v-if="[-1].includes(resultFlag)">
      <div class="zhuanpan">
        <img
          src="../assets/zhuanpan.png"
          alt=""
          ref="zhuanpan"
          :style="{ transform: 'rotate(' + deg + 'deg)' }"
          style="transition: transform 5s ease-in-out"
        />
        <img src="../assets/zhen.png" alt="" class="zhen" />
      </div>
      <img src="../assets/drawBtn.png" alt="" class="btn" @click="getDraw()" />
    </div>
    <!-- <div class="fenxiang" v-if="fxjtFlag == true">
      <img src="../assets/fx.png" alt="" />
    </div> -->
    <div class="page" v-if="[0].includes(resultFlag)"></div>
    <img
      src="../assets/fxjt.png"
      alt=""
      v-show="fxjtFlag == true"
      class="fxjt"
      v-if="[0].includes(resultFlag)"
    />
    <div class="btnGroup" v-if="[0].includes(resultFlag)">
      <img src="../assets/zwyc.png" alt="" @click="zwyc()" />
      <img src="../assets/zffx.png" alt="" @click="zffx()" />
    </div>
    <div v-if="[1, 2, 3].includes(resultFlag)" class="formData">
      <h6>恭喜你 获得{{ whatDraw }}等奖!</h6>
      <p>请在下方输入您的信息，我们将为您充值到指定的手机号中</p>
      <div class="form">
        <van-form ref="phoneSubmit" @submit="formSubmit">
          <h3>请输入您的姓名：</h3>
          <van-field
            v-model="name"
            clearable
            :rules="[{ required: true, message: '请填写用户名' }]"
          />
          <h3>请输入您的美团单车注册的手机号:</h3>
          <van-field
            validate-first
            v-model="phone"
            clearable
            :rules="[{ validator, message: '手机号格式有误' }]"
          />
          <van-button round block type="info" native-type="submit" size="mini"
            >提交</van-button
          >
        </van-form>
      </div>
    </div>
    <div v-if="[1].includes(tishiFlag)" class="tshi">
      <img src="../assets/tjcg.png" alt="" class="imgText" />
      <img src="../assets/back.png" alt="" class="btn" @click="backIndex()" />
    </div>
    <div v-if="[2].includes(tishiFlag)" class="tshi">
      <img src="../assets/tjsb.png" alt="" class="imgText" />
      <img src="../assets/back.png" alt="" class="btn" />
    </div>
  </div>
</template>

<script>
import { Notify } from "vant";
export default {
  name: "luckDraw",
  data() {
    return {
      drawFlag: true,
      deg: "0",
      paper: [],
      resultFlag: -1,
      tishiFlag: 0,
      name: "",
      phone: "",
      fxjtFlag: false,
      whatDraw: "",
    };
  },
  mounted() {
    this.paper = this.$route.query.paper;
    console.log(this.paper);
  },
  methods: {
    validator(val) {
      return /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/.test(
        val
      );
    },
    zffx() {
      this.fxjtFlag = true;
    },
    zwyc() {
      this.$router.push({
        path: "/answer",
      });
    },
    backIndex() {
      this.$router.push({
        path: "/",
      });
    },
    encode(str) {
      // 对字符串进行编码
      var encode = encodeURI(str);
      // 对编码的字符串转化base64
      var base64 = btoa(encode);
      return base64;
    },
    formSubmit() {
      let data = {
        name: this.name,
        phone: this.phone,
      };
      this.$axios
        .post("http://tp5.scimall.org/portal/Jhzs8/storeMsg", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          this.tishiFlag = res.data.status;
          if (res.data.status == 3) {
            Notify({ type: "success", message: "您已提交过了~" });
            this.resultFlag = -1;
          }
          if (res.data.status == 4) {
            Notify({ type: "danger", message: "您未中奖~" });
            this.resultFlag = -1;
          }
        })
        .catch((err) => {});
    },
    getDraw() {
      if (this.drawFlag == true) {
        this.drawFlag = false;
        let timestamp = Date.parse(new Date());
        timestamp = timestamp / 1000 - 123456;
        let token = timestamp + "DFERGT";
        token = this.encode(token);
        console.log(token);
        let data = {
          point: this.paper,
          token: token,
        };
        this.$axios
          .post("http://tp5.scimall.org/portal/Jhzs8/doAward", data, {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              Accept: "application/vnd.edusoho.v2+json",
            },
          })
          .then((res) => {
            console.log(res);
            if (res.data.status == 0) {
              this.draw(0);
            } else if (res.data.status == 1) {
              if (res.data.level == 1) {
                this.whatDraw = "一";
              } else if (res.data.level == 1) {
                this.whatDraw = "二";
              } else {
                this.whatDraw = "三";
              }

              this.draw(parseInt(res.data.level));
            } else {
              Notify({ type: "danger", message: res.data.msg });
            }
          })
          .catch((err) => {});
      }
    },
    draw(status) {
      if (status == 0) {
        let deg = -(360 * 8 + 75);
        this.deg = deg;
        setTimeout(() => {
          this.resultFlag = status;
        }, 6000);
      }
      if (status == 1) {
        let deg = -(360 * 10 + 105);
        this.deg = deg;
        setTimeout(() => {
          this.resultFlag = status;
        }, 6000);
      }
      if (status == 2) {
        let deg = -(360 * 9 + 15);
        this.deg = deg;
        setTimeout(() => {
          this.resultFlag = status;
        }, 6000);
      }
      if (status == 3) {
        let deg = -(360 * 9 + 45);
        this.deg = deg;
        setTimeout(() => {
          this.resultFlag = status;
        }, 6000);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.luckDraw {
  width: 100vw;
  height: 100%;
  position: relative;
  overflow: hidden;
  display: block;
  .tshi {
    width: 100%;
    height: 100%;
    .imgText {
      width: 100%;
      margin: 10vh auto;
    }
    .btn {
      width: 30%;
      margin: 0 auto;
      display: block;
    }
  }
  .formData {
    width: 100%;
    height: 115vw;
    background-image: url("../assets/txxx.png");
    background-size: 100% 100%;
    position: absolute;
    .van-button--info {
      color: #fff;
      background-color: #ffc14a;
      border: 1px solid #ffffff;
    }
    .van-button--block {
      margin: 1vw auto;
      display: block;
      width: 30%;
    }
    .tjBtn {
      width: 25%;
      margin: 2vw auto;
      display: block;
    }
    top: 10vh;
    .van-cell {
      position: relative;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 60%;
      padding: 4px 6px;
      margin: 0 auto;
      overflow: hidden;
      color: #323233;
      font-size: 14px;
      line-height: 24px;
      background-color: #ffdb96;
      border-radius: 8px;
    }
    h6 {
      font-size: 6vw;
      text-align: center;
      color: #ff8b00;
      margin-top: 35vw;
    }
    h3 {
      color: #964221;
      font-size: 4vw;
      margin: 0;
      padding: 0;
      margin-top: 1vw;
    }
    p {
      font-size: 4vw;
      text-align: center;
      color: #ff8b00;
      width: 60%;
      text-align: center;
      display: block;
      font-weight: 600;
      margin: -5vh auto;
    }

    .form {
      width: 68%;
      margin: 0 auto;
      margin-top: 5vh;
      text-align: center;
    }
  }
  .fxjt {
    width: 10vw;
    position: absolute;
    right: 5vw;
    top: 5vw;
  }
  .page {
    width: 90%;
    margin: 20vh auto;
    height: 75vw;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-image: url("../assets/wzjPage.png");
  }
  .btnGroup {
    width: 90%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    img {
      width: 35%;
    }
  }
  .fenxiang {
    width: 10vw;
    height: 10vw;
    position: absolute;
    top: 2vh;
    right: 2vh;
    img {
      width: 100%;
    }
  }
  .top {
    width: 100%;
    margin-top: 10vh;
    height: 100vh;
    background-size: 100%;
    background-repeat: no-repeat;
    display: block;
    overflow: hidden;
    background-image: url("../assets/zhuanpanbj.png");
    .zhuanpan {
      margin: 15vh auto 0;
      width: 80vw;
      height: 80vw;
      border-radius: 40vw;
      display: block;
      position: relative;
      transform-origin: 50% 50%;
      img {
        width: 100%;
      }
      .zhen {
        position: absolute;
        height: 20vh;
        width: 10vw;
        top: calc(40vw - 20vh);
        left: calc(40vw - 5vw);
      }
    }
    .btn {
      display: block;
      width: 40vw;
      margin: 5vh auto;
    }
  }
}
</style> 



// WEBPACK FOOTER //
// src/pages/luckDraw.vue